export const VIEW_KEY_PREFIX = "emailpa-";
export const DEFAULT_VIEW = "expanded";

export const storageKeyFor = (scope) => `${VIEW_KEY_PREFIX}${scope || "contact"}-view`;

export const normalizeView = (view) => (view === "compact" ? "compact" : "expanded");

export const getSavedView = (scope = "contact", fallback = DEFAULT_VIEW) => normalizeView(localStorage.getItem(storageKeyFor(scope)) || fallback);

export const applyView = (view, root = document) => {
    const next = normalizeView(view);
    root.querySelectorAll("[data-contact-view]").forEach((el) => {
        el.setAttribute("data-contact-view", next);
    });
};

export const setView = (view, root = document, scope = "contact") => {
    const next = normalizeView(view);
    localStorage.setItem(storageKeyFor(scope), next);
    applyView(next, root);
    document.dispatchEvent(new CustomEvent("emailpa:contactviewchange", { detail: { view: next, scope } }));
};

export const resolveView = (urlParam, scope = "contact", fallback = DEFAULT_VIEW) => {
    if (urlParam === "compact" || urlParam === "expanded") return urlParam;
    return normalizeView(localStorage.getItem(storageKeyFor(scope)) || fallback);
};

// Legacy export for any code still using the old key name.
export const VIEW_KEY = storageKeyFor("contact");
